"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _timezones = _interopRequireDefault(require("../definitions/timezones"));

var _timeFormatting = _interopRequireDefault(require("./time-formatting"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const {
  concatAmAndPm,
  getClientLocation,
  isDSTActive
} = _timeFormatting.default;

function timezoneOptionFormatter(timezone, dstFormartted, withTime = true, localeStrFormat = 'en-US') {
  // Add label to timezone formatted according requested localize specification
  let localizedDateStr;

  try {
    localizedDateStr = new Date().toLocaleString(localeStrFormat, {
      timeZone: timezone.timezone
    });
  } catch (error) {
    console.log(error); // this try catch is here for test environment

    return {};
  } // When client on DST timezone, show DST name. Otherwise show nornal name


  const timezoneName = dstFormartted ? timezone.dstName : timezone.name; // Timezone locale name (ex: America || Europe)

  const timezoneLocaleName = timezoneName.split(' ').join('');
  const uniqueTimezoneKey = `${timezone.utcOffsetStr}/${timezone.dstOffsetStr}/${timezoneLocaleName}`;
  return { ...timezone,
    optValue: uniqueTimezoneKey,
    optLabel: `${timezoneName} ${withTime ? `(${concatAmAndPm(new Date(localizedDateStr))})` : ''}`
  };
}

let supportedTimezones = null;

function generateFullSupportedTimezonesOptions() {
  if (supportedTimezones) {
    return supportedTimezones;
  } // Checking if we are currently on DST timezone


  const currentlyOnDST = isDSTActive(); // Timezone options according if we are on DST or not

  const timezones = _timezones.default.getSupportedTimezones();

  const parsedTimezones = timezones.map(timezone => timezoneOptionFormatter(timezone, currentlyOnDST)); // Sorting matching timezone according correct offset, according we're in DST timezone or not

  const sortByProp = currentlyOnDST ? 'dstOffset' : 'utcOffset';
  supportedTimezones = parsedTimezones.sort((a, b) => a[sortByProp] - b[sortByProp]);
  return supportedTimezones;
}

function getTimezoneString(timezoneValue) {
  const parsedTimezones = generateFullSupportedTimezonesOptions();
  const result = parsedTimezones.find(timezone => timezone.optValue === timezoneValue) || {
    name: ''
  };
  return result.name;
}

function getTimezoneAcronym(timezoneValue) {
  const timezoneName = getTimezoneString(timezoneValue);
  const timezoneWithoutDateString = timezoneName.split(',')[1] || timezoneName;
  const result = timezoneWithoutDateString.split(' ').map(s => s.charAt(0)).join('');
  return result;
}

let timezonesInfo = null;

function getUserTimezoneData() {
  if (timezonesInfo) {
    return timezonesInfo;
  } // Defaults


  const userTimezoneOptions = generateFullSupportedTimezonesOptions();
  const userDefaultTimezoneSelected = userTimezoneOptions[0].optValue; // Check if some supported timezone matches user case

  const location = getClientLocation();
  const usersTimezone = userTimezoneOptions.find(f => {
    var _f$aliasList;

    return (_f$aliasList = f.aliasList) === null || _f$aliasList === void 0 ? void 0 : _f$aliasList.includes(location);
  });

  if (!usersTimezone) {
    timezonesInfo = {
      timezoneOptions: userTimezoneOptions,
      defaultTimezone: userDefaultTimezoneSelected
    };
    return timezonesInfo;
  }

  timezonesInfo = {
    timezoneOptions: userTimezoneOptions,
    defaultTimezone: usersTimezone.optValue
  };
  return timezonesInfo;
}

var _default = {
  getUserTimezoneData,
  getTimezoneString,
  getTimezoneAcronym,
  generateFullSupportedTimezonesOptions
};
exports.default = _default;